import React from 'react';
import Navbar               from './Navbar';
import Hero                 from './Hero';
import TrustStrip           from './TrustStrip';
import CategoryCards        from './CategoryCards';
import PopularRolesGrid     from './PopularRolesGrid';
import AudienceSwitcher     from './AudienceSwitcher';
import AIFeatures           from './AIFeatures';
import PlacementERPBand     from './PlacementERPBand';
import WorkforceBand        from './WorkforceBand';
// import CommunityBand        from './CommunityBand'; // temporarily hidden
import VisionMissionPurpose from './VisionMissionPurpose';
import TestimonialsAndLogos from './TestimonialsAndLogos';
import WhatsAppBanner       from './WhatsAppBanner';
import FAQ                  from './FAQ';
import FinalCTA             from './FinalCTA';
import Footer               from './Footer';

export default function NewLanding({ onSignIn, onStartSearching }) {
  return (
    <div className="min-h-screen bg-paper text-ink-900 selection:bg-brand-purple selection:text-white">
      <Navbar               onSignIn={onSignIn} onPostJob={onStartSearching} />
      <Hero                 onStartSearching={onStartSearching} />
      <TrustStrip />
      <CategoryCards        onStartSearching={onStartSearching} />
      <PopularRolesGrid     onStartSearching={onStartSearching} />
      <AudienceSwitcher     onStartSearching={onStartSearching} />
      <AIFeatures />
      <PlacementERPBand     onStartSearching={onStartSearching} />
      <WorkforceBand        onStartSearching={onStartSearching} />
      {/* <CommunityBand /> */}{/* temporarily hidden */}
      <VisionMissionPurpose />
      <TestimonialsAndLogos />
      <WhatsAppBanner />
      <FAQ />
      <FinalCTA             onStartSearching={onStartSearching} />
      <Footer />
    </div>
  );
}
